import {Modal} from 'antd';
import {jwtDecode} from 'jwt-decode';
import {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useNavigate} from 'react-router-dom';

import {logoutStart} from '../../redux/authAction';

const SessionExpiredModal = () => {
  const navigate = useNavigate();

  const [isModalOpen, setIsModalOpen] = useState(true);

  const dispatch = useDispatch();

  const {token, loggedIn} = useSelector(state => state.auth);

  useEffect(() => {
    if (token) {
      const decodedToken = jwtDecode(token);
      const currentTime = Math.floor(Date.now() / 1000);

      if (decodedToken.exp < currentTime && loggedIn) {
        setIsModalOpen(true);
      }
    } else if (loggedIn) {
      setIsModalOpen(true);
    }
  }, [token, loggedIn]);

  const handleOk = () => {
    dispatch(logoutStart());
    navigate('/login');
    setIsModalOpen(false);
  };

  return (
    <Modal
      title={'Session Expired'}
      visible={isModalOpen}
      onOk={handleOk}
      closable={false}
      maskClosable={false}
      cancelButtonProps={{style: {display: 'none'}}}
    >
      <p className={'text-md'}>Your session has expired. Please login again to continue.</p>
    </Modal>
  );
};

export default SessionExpiredModal;
